export const getCookieValueByKey = (key) => {
  const allCookieStrings = (document.cookie || "").split("; ");
  const cookieString = allCookieStrings.find(
    (string) => string.indexOf(`${key}=`) === 0
  );
  if (!cookieString) return null;
  const value = cookieString.split("=")[1];
  return value;
};

export const hasCookieConsent = (consentLevel) => {
  if (process.env.GATSBY_LOCAL_DEBUG_OVERRIDE_COOKIE_CONSENT) return true;

  if (!consentLevel || typeof window.ikea?.cookieConsent === "undefined") {
    return true;
  }

  if (window.ikea.cookieConsent?.hasConsent) {
    return window.ikea.cookieConsent.hasConsent(consentLevel);
  }

  return false;
};
